import { IconCheck, IconInfoCircle } from '@maia/icons';
import { HTMLAttributes, ReactNode, useId } from 'react';
import { twMerge } from 'tailwind-merge';
import { cardStyles, FeaturedIcon, TextButton, Typography } from '../../ui';

type Props = {
  icon: ReactNode;
  title: string;
  description?: string;
  usps?: Array<string>;
  onClickMoreInformation?: () => void;
} & HTMLAttributes<HTMLDivElement>;

export function ProductIntro(props: Props) {
  const id = useId();
  const { icon, title, description, usps, onClickMoreInformation, ...rest } =
    props;

  return (
    <div {...rest}>
      <div className="flex flex-row gap-x-16">
        <FeaturedIcon icon={icon} variant="light-square" size="md" />
        <div className="flex flex-col gap-y-4">
          <Typography
            variant="display6"
            weight="semibold"
            className="text-grayscale600"
          >
            {title}
          </Typography>
          {description && (
            <Typography
              variant="body-s"
              weight="regular"
              className="text-grayscale400"
            >
              {description}
            </Typography>
          )}
        </div>
      </div>

      {usps && usps.length > 0 && (
        <div className="flex flex-col mt-32 gap-y-8">
          <div className="flex flex-row items-center">
            <Typography
              variant="body-s"
              weight="regular"
              className="text-grayscale500 flex-1"
            >
              Perfect voor als ...
            </Typography>

            {onClickMoreInformation && (
              <TextButton
                size="tiny"
                iconRight={IconInfoCircle}
                className="underline"
                onPress={onClickMoreInformation}
              >
                Meer informatie
              </TextButton>
            )}
          </div>

          <div className={twMerge(cardStyles({ variant: 'flat' }), 'p-20')}>
            <ul className="space-y-4">
              {usps?.map((usp, index) => (
                <li
                  className="flex flex-row gap-x-8"
                  key={`product-intro-${id}-usp-${index}`}
                >
                  <IconCheck className="min-w-24 w-24 h-24 fill-success300" />
                  <Typography
                    variant="body-s"
                    weight="medium"
                    className="text-grayscale500"
                  >
                    {usp}
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
